import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TgRackModule } from '@trademe/tangram';
import { PropertyAboutSectionModule } from '../../../sections/property-default-sections/property-about-section/property-about-section.module';
import { PropertyDescriptionPageComponent } from './property-description-page.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TgRackModule,
        PropertyAboutSectionModule
    ],
    declarations: [PropertyDescriptionPageComponent],
    exports: [PropertyDescriptionPageComponent]
})
export class PropertyDescriptionPageModule {}
